define('modules/list/list_item_model',['backbone'], function(Backbone) {
 'use strict';
 var Item = Backbone.Model.extend({
  defaults: function() {
    return {

    };
  }
});

 return Item;
});
